// extracted by mini-css-extract-plugin
module.exports = {"journalistContainer":"JournalistQuotes_journalistContainer___JFVb","journalistLogo":"JournalistQuotes_journalistLogo__E0gcq"};